<template>
    <div class="container">
        <v-header></v-header>
        <header-searchtwo></header-searchtwo>
        <div class="content-box">
            <div id="shop_car">
                <section class="car_main">
                    <!--顶部列表-->
                    <div class="cart_top">
                        <div class="car_top_item" :class="{'active':cartchoose==0}" @click="choosecart(0)">大货商品20</div>
                        <div class="car_top_item" :class="{'active':cartchoose==1}" @click="choosecart(1)">打样商品10</div>
                    </div>

                    <!--商品信息-->
                    <div class="car_head">
                        <ul class="car_top">
                            <li class="car_information">商品</li>
                            <li class="car_size">规格</li>
                            <li class="car_number">数量</li>
                            <li class="car_price">参考金额</li>
                            <li class="car_operation">操作</li>
                        </ul>
                    </div>
                    <!--购物车为空时展示页面-->
                     <template v-if="goods.length==0">
                         <div class="cart_empty">
                             您的购物车还是空的哦，快去挑选您喜欢的东西吧.
                         </div>
                     </template>
                    <!--购物车详情展示-->
                    <template v-else>


                                <!--商品详细标题-->

                                <div v-for="(product,product_index) in goods" :key="product_index"   class="product"  
                                     v-bind:class="[product.product_checked ? 'selected_styles' : '']">
                                    <!-- <div class="product_description" v-if="product.product_description != ''">
                                         <div class="product_description_bg">{{product.product_description}}</div>
                                     </div>-->
                                    <div class="product_details">

                                        <!--商品是否选中-->
                                        <div class="product_check">
                                            <div class="product_check_checkbox">
                                            <el-checkbox v-model="product.product_checked"
                                                         @change="product_checked_click(product_index)" ></el-checkbox>
                                           <!-- <input type="checkbox" v-model="product.product_checked"
                                                   @click="product_checked_click(shop_index,product_index)"/>-->
                                            </div> </div>

                                        <!--商品图片-->
                                        <div class="product_img">
                                            <img :src="product.url" style="width: 100px;height: 100px"/>
                                        </div>
                                        <!--商品名称-->
                                        <div class="product_shop_info">
                                            <div class="product_shop_name">
                                               <!-- <a :href="product.href">-->{{product.product_name}}<!--</a>-->
                                            </div>
                                            <div class="product_price_origin">
                                                ￥99
                                            </div>
                                        </div>

                                        <!--商品尺寸颜色等属性-->
                                        <div class="product_type_select">
                                            <div class="product_type_all">
                                                <div v-for="type in product.product_type" class="product_type" :key="type.value">
                                                    {{type.key}}: {{type.value}}
                                                </div>

                                            </div>
                                        </div>



                                        <!--商品数量-->
                                        <div class="product_number">
                                            <div class="product_number_content">
                                                <div class="product_number_button" v-if="product.number > 1" @click="product_reduce(product_index)">-</div>
                                                    <div class="product_number_button" v-else >-</div>
                                                <div class="product_number_input">
                                                    <input type="number" v-model="product.number" readonly/>
                                                </div>
                                                <div class="product_number_button"
                                                     @click="product_add(product_index)">
                                                   +
                                                </div>
                                            </div>
                                        </div>

                                        <!--商品价格-->
                                        <div class="product_amount">
                                            <div class="product_total_price">￥{{
                                                product_total_price(product_index) | priceFilter}}
                                            </div>
                                        </div>

                                        <!--操作选项-->
                                        <div class="product_operation">
                                            <div>
                                                <button @click="product_del(product_index)">删除</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                    </template>

                </section>
            </div>

        </div>

        <!--底部页面-->
        <div class="car_foot_bar">
            <div class="car_foot_settle">
                <div class="car_check_all">

                    <div class="car_check_all_box" >
                    <el-checkbox v-model="checked_all"   @change="all_products_checked" >全选</el-checkbox>
                    </div>
                    <div class="delete_all" @click="product_del_all">删除</div>
                </div>
                <div>
                    <div class="piece">已选商品 <strong class="piece_num">{{selected_products}}</strong> 件</div>
                    <div class="totalMoney">参考合计 : <strong class="total_text">￥{{total_amount |
                        priceFilter}}</strong> 元
                    </div>
                    <div class="settle_accounts" >
                        <!--<div class="settle_button" :disabled="selected_products == 0 ? true : false"
                             @click="shop_settle">结算</div>-->
                        <button class="settle_button" :disabled="selected_products == 0 ? true : false"
                                @click="shop_settle">
                        结算
                       </button>
                    </div>
                </div>
            </div>
        </div>

        <v-footer></v-footer>
    </div>
</template>

<script>
    import header from "../header";
    import footer from "../footer";
    import headersearchtwo from "../headersearchtwo";
    export default {
        name: "shopCart",
        components: {
            "v-header": header,
            "v-footer": footer,
            "header-searchtwo": headersearchtwo,
        },
        data() {
            return {
                cartchoose:0,//商品类型初始值
                goods:[
                    {
                        product_name: '酒店空气清新剂家用卧室持久留香卫生间除味剂除臭香薰喷香机香水',
                        product_description: '空喷买2送',
                        url: 'https://senkoo-mall.oss-cn-shanghai.aliyuncs.com/store/1.JPG',
                        href: 'https://detail.tmall.com/item.htm?spm=a1z0d.6639537.1997196601.4.ff9a7484vD2sXY&id=527905990976',
                        edit_type: false,
                        product_type: [
                            {
                                id: 1,
                                key: '尺码',
                                value: 'XXL'
                            },
                            {
                                id: 2,
                                key: '颜色',
                                value: '青色'
                            }
                        ],
                        current_price: 32.80,
                        origin_price: 68.00,
                        number: 1,
                        product_checked: false,
                    },
                    {
                        product_name: '遇见香芬COCO沐浴露持久留香72小时男女学生香水补水家庭装非美白',
                        product_description: '普通商品',
                        url: 'https://senkoo-mall.oss-cn-shanghai.aliyuncs.com/store/2.jpg',
                        href: 'https://detail.tmall.com/item.htm?spm=a1z0d.6639537.1997196601.13.6e517484kyYSnq&id=39252128018',
                        edit_type: false,
                        product_type: [
                            {
                                id: 1,
                                key: '尺码',
                                value: 'XXL',
                            }
                        ],
                        current_price: 36.80,
                        origin_price: 98.00,
                        number: 1,
                        product_checked: false,
                    },
                    {
                        product_name: 'Herman Miller Embody 座椅 标准配置【Rhythm织物】',
                        product_description: '空喷买2送',
                        url: 'https://senkoo-mall.oss-cn-shanghai.aliyuncs.com/store/3.jpg',
                        href: 'https://detail.tmall.com/item.htm?spm=a1z0d.6639537.1997196601.4.ff9a7484vD2sXY&id=527905990976',
                        edit_type: false,
                        product_type: [
                            {
                                id: 1,
                                key: '扶手类型',
                                value: '升降扶手'
                            },
                            {
                                id: 2,
                                key: '颜色分类',
                                value: '蓝莓色'
                            },
                            {
                                id: 3,
                                key: '五星脚材质',
                                value: '钢制脚'
                            }
                        ],
                        current_price: 9992.00,
                        origin_price: 0,
                        number: 1,
                        product_checked: false,
                    },
                    {
                        product_name: 'Panasonic松下音响 无线话筒 便携扩音器WS-X66教学会议演讲培训',
                        product_description: '空喷买2送',
                        url: 'https://senkoo-mall.oss-cn-shanghai.aliyuncs.com/store/1.JPG',
                        href: 'https://jiashiyoudq.tmall.com/',
                        edit_type: false,
                        product_type: [
                            {
                                id: 1,
                                key: '颜色分类',
                                value: '最佳套餐WS-X66音响+wx4800话筒'
                            }
                        ],
                        current_price: 2950.00,
                        origin_price: 3050.00,
                        number: 1,
                        product_checked: false,
                    },
                    {
                        product_name: '韩伊橄榄Olive润肤清爽沐浴露去油沐浴乳 滋润清香洗澡液500ml\n',
                        product_description: '超值换购活动',
                        url: 'https://senkoo-mall.oss-cn-shanghai.aliyuncs.com/store/1.JPG',
                        href: 'https://chaoshi.tmall.com',
                        edit_type: false,
                        product_type: [
                            {
                                id: 1,
                                key: '颜色分类',
                                value: '500ml'
                            }
                        ],
                        current_price: 25.90,
                        origin_price: 0,
                        number: 1,
                        product_checked: false,
                    }
                ],
                // 其他属性数据
                checked_all: false
            }
        },
        mounted:function(){
            /*this.createcode();//需要触发的函数*/
            console.log("goods长度",this.goods.length)
        },
        methods: {
            // 选择购物车2大类之一
            choosecart(index){
                this.cartchoose=index;
            },



            // 结算
            shop_settle() {
                alert('大哥微信支付吧，快来扫我！')
            },


            // 商品总价
            product_total_price( product_index) {
                var product = this.goods[product_index]
                return product.number * product.current_price
            },

            // 减购商品，每次减少1
            product_reduce(product_index) {
                var product = this.goods[product_index]
                if ((product.number - 1)) {
                    product.number--
                }
            },

            // 加购，每次加1
            product_add( product_index) {
                var product = this.goods[product_index]
                if ((product.number + 1) < 100) {
                    product.number++
                }
            },

            // 删除购买商品
            product_del( product_index) {
                console.log( product_index)
                this.goods.splice(product_index, 1)
            },


           // 删除多个商品
            product_del_all() {
                console.log("fwewewef")
                for (var i = 0; i < this.goods.length; i++) {
                    if (this.goods[i].product_checked==true) {
                        console.log(i)
                        this.goods.splice(i, 1)
                        i--;
                    }
                }

            },




            // 商品选择时
            product_checked_click( product_index) {

                // 检测购物车内的商品是否全部选中
                for (var i = 0; i < this.goods.length; i++) {
                   /* console.log("顺序",i,this.goods[i].all_checked)*/
                    if (!this.goods[i].product_checked) {
                        console.log("没都选择",this.goods[i].product_checked)
                        this.checked_all = false
                        return
                    }
                }
                    console.log("都选中了")
                this.checked_all = true
            },

            // 检测购物车内的商品全部
            all_products_checked() {
                   console.log("全选",this.checked_all)
                /*this.checked_all = !this.checked_all*/
                console.log(this.checked_all)
                for (var i = 0; i < this.goods.length; i++) {
                    this.goods[i].product_checked= this.checked_all
                }
            },
        },
        filters: {
            // 金额显示过滤 两位小数点，不足补0
            priceFilter(value) {
                var value = Math.round(parseFloat(value) * 100) / 100;
                var xsd = value.toString().split(".");
                if (xsd.length == 1) {
                    value = value.toString() + ".00";
                    return value;
                }
                if (xsd.length > 1) {
                    if (xsd[1].length < 2) {
                        value = value.toString() + "0";
                    }
                    return value;
                }
            }
        },

        computed: {

            // 已选择商品数目
            selected_products() {
                var selected_products = 0
                for (var i = 0; i < this.goods.length; i++) {
                    var product = this.goods[i]

                        if (this.goods[i].product_checked) {
                            selected_products++

                    }
                }
                return selected_products
            },

            // 购买商品总金额
            total_amount() {
                var total_price = 0.00
                for (var i = 0; i < this.goods.length; i++) {
                    var product = this.goods[i]
                    if (this.goods[i].product_checked) {
                        total_price += this.goods[i].number *this.goods[i].current_price
                    }
                   /* for (var j = 0; j < product.length; j++)
                        if (product[j].product_checked) {
                            total_price += product[j].number * product[j].current_price
                        }*/
                }
                return total_price
            },

            // 购物车全选
            all_checked() {
                for (var i = 0; i < this.goods.length; i++) {
                    if (!this.goods[i].all_checked) {
                        return false
                    }
                }
                return true
            }
        }
    }

</script>

<style lang="scss" scoped>
    .container {
        width: 100%;
     /*   background: #ffffff;*/
    }

    .content-box {
        width: 100%;
        margin: 0px auto;
        background: #ffffff;

    }
 #shop_car{
     width: 1200px;
     margin: 0px auto;

 }
    /*********购物车****/
    .car_main {
        width: 1200px;
        margin: 0px auto;
        padding-bottom: 20px;
       /* padding: 0px 0px;*/
        min-height: 250px;



    }

    /**********顶部菜单**********/
    .cart_top{
        width: 1200px;
        height: 50px;
        line-height: 50px;
        margin: 0px auto;
        border-bottom: solid 1px  #E8E8E8;
        display: flex;
        justify-content: flex-start;
    }
    .car_top_item{
        width: 140px;
        height: 50px;
        line-height: 50px;
        text-align: center;
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: rgba(0,0,0,0.85);
    }
/***********大件和小样选中样式************/
 .active{
     font-family: PingFangSC-Medium;
     font-size: 16px;
     color: #EF2D23;
     border-bottom: solid 2px #EF2D23;
 }

    .car_head {
        width: 100%;
        height: 50px;
        line-height: 50px;
        color: #3c3c3c;
        font-size: 14px;
        padding: 0px;
      /*  border-bottom: 1px solid #DCDCDC;*/
    }

    .car_top {
        width: 100%;
        height: 50px;
    }

    ul {
        list-style: none;
    }

    li {
        float: left;
        text-align: left;
    }


    .car_information {
        width: 590px;
        padding-left: 40px;

    }

    .car_size {
        width: 190px;

    }

    .car_number {
        width: 170px;

    }

    .car_price{
        width: 150px;
        text-align: center;

    }
   .car_operation{
       width: 100px;
       text-align: center;

   }
    .cart_empty {
       /* position: absolute;*/
        width: 1200px;
        line-height: 40px;
        margin-top:10%;
        margin-bottom: 10%;
        text-align: center;
    }




    .product_details {
        width: 100%;
        height: 130px;
        display: flex;
        justify-content: flex-start;
        margin-bottom: 10px;
        border: 1px solid #D9D9D9;
        margin-top: 10px;
    }




    .product_check {
        width: 40px;
        height: 130px;
    }

    .product_img {
        width: 150px ;
        height: 130px;
    }
    .product_img img{
        width: 150px;
        height: 110px;
      margin-top: 15px;
        margin-left: 25px;

    }

    .product_shop_info {
        height: 130px;
      /*  padding-left: 20px;*/
        width: 400px;
        padding-right: 20px;
        display: flex;
        flex-wrap: wrap;
        align-content: space-between;
    }

    .product_shop_name {
        font-size: 12px;
        text-align: left;
        padding-top: 15px;
        ext-decoration: none;
        letter-spacing: 2px;
        color: #3c3c3c;
        line-height: 25px;
    }
    .product_price_origin{
        line-height: 25px;
        margin-bottom: 15px;
    }





    .product_type_select {
        width: 190px;
        height: 130px;
    }
    

    .product_type_all {
        width: 180px;
        height: 130px;
        padding: 0;
        margin: 0;
        display: flex;
        flex-wrap: wrap;
        align-content: center;
    }

    .product_type {
        width: 180px;
       line-height:25px;
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: rgba(0,0,0,0.65);
    }



    .product_number {
        width: 170px;
    }

    .product_number_content {
        width: 170px;
        height: 30px;
        display: flex;
        justify-content: flex-start;
        margin-top: 50px;
    }

    .product_number_button {
        width: 30px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        font-size: 20px;
        border: 1px solid #D9D9D9;

    }



    .product_number_input {
        width: 70px;
        height: 30px;
        text-align: center;

    }


    .product_number_input input {
        width: 70px;
        height: 30px;
        line-height: 30px;
        text-align: center;
        box-sizing: border-box;
        outline: none;
        border: 1px solid #D9D9D9;
    }



    .product_amount {
        width: 150px;
        height: 130px;
        line-height: 130px;
        text-align: center;
        font-size: 16px;
        color: red;
        font-weight: bold;
        word-wrap: break-word;
    }


    .product_operation {
        width: 100px;
        height: 130px;
        line-height: 130px;
        text-align: center;
        color: #3c3c3c;
        border: none;
        outline: none;
        font-size: 12px;
    }

    .product_operation button {
        width: fit-content;
        border: none;
        background: transparent;
        outline: none;
        font-size: 12px;
    }

    .product_operation button:hover {
        color: red;
        text-decoration: underline;
    }

   /* .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
        background-color: #EF2D23!important;
    }*/
      /*修改饿了么复选框样式*/
/*    .el-checkbox__input.is-checked .el-checkbox__inner{
        background-color:rgba(239, 45, 35, 1)!important;
    }
    .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{
        background-color:rgba(239, 45, 35, 1);
        border-color: rgba(47, 84, 201, 1);
    }
    .el-checkbox__input.is-checked + .el-checkbox__label {
        color: rgba(47, 84, 201, 1);
    }
    .el-checkbox.is-bordered.is-checked{
        border-color: rgba(47, 84, 201, 1);
    }
    .el-checkbox__input.is-focus .el-checkbox__inner{
        border-color:  rgba(47, 84, 201, 1);
    }*/

.product_check_checkbox{
    margin-left: 10px;
    margin-top: 60px;
}

    /************底部结算*********/

    .car_foot_bar {
        position: fixed;
        bottom: 0;
        width: 100%;
        height: 50px;
        font-size: 14px;
        color: #3c3c3c;
        background: #ffffff;
        z-index: 999;
    }

    .car_foot_settle {
        width: 1200px;
        height: 50px;
        margin: 0px auto;
        display: flex;
        justify-content: space-between;
        /* background: red;
 */
    }
    .car_check_all {
        width:120px ;
        display: flex;
        justify-content: space-between;
    }
  .delete_all{
      width: 40px;
      line-height: 50px;
  }

    .car_check_all label {
    }



    .car_check_all_box{
        margin-top: 15px;
    }


    .piece {
        float: left;
        height: 50px;
        line-height: 50px;
    }

    .totalMoney {
        float: left;
        margin-left: 20px;
        height: 45px;
        line-height: 45px;
    }

    .settle_accounts {
        float: left;
        margin-left: 20px;
        height: 50px;
        line-height: 50px;
    }

    .piece_num {
        color: red;
    }

    .total_text {
        color: red;
        font-size: 18px;
    }

    .settle_button {
        width: 144px;
        height: 50px;
        line-height: 50px;
        border: none;
        outline: none;
        background-color: red;
        color: #ffffff;

    }

    .settle_button:disabled {
        background-color: #c0c1d1;
        color: #001f3f;
    }



    .shop_info li a {
        text-decoration: none;
        margin-right: 10px;
        color: #3c3c3c;
    }

    .shop_info li a:hover {
        color: red;
        text-decoration: underline;
    }





</style>